import React from 'react';
import Icon from '../icon/Icon';
import { cn } from '@/lib/utils';
import { FAStackWrapper } from './shared';

type HistoricalIconProps = {
  /** Fill the icon with solid color */
  color: string;
  className?: string;
};

export const HistoricalPortfolioIcon = ({ className, color }: HistoricalIconProps) => {
  return (
    <FAStackWrapper className={cn('fa-stack', className)} data-testid="historical-portfolio-icon">
      <Icon type="folder" className="fa-stack-2x" style={{ color }} />
    </FAStackWrapper>
  );
};
